export default ({ req }, inject) => {
  let currentDomain = null;

  if (process.server) {
    currentDomain = req.headers.host;
  } else {
    currentDomain = window.location.hostname;
  }
  inject('currentDomain', currentDomain);
}
